export function executeOnServer<T>(callback: () => void): T | void {
  if (!process.server || !callback) return undefined

  return callback()
}

export default {
  executeOnServer,
}
